import React from 'react'

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
function Success() {
  return (
    <>
      <Card sx={{ width: 1, paddingBottom: 6, paddingTop: 6, boxShadow: "none", border: '1px double #58A618' }}>
        <CardContent>
          <CheckCircleOutlineIcon sx={{ fontSize: 180, color: '#58A618' }} />
          <Typography sx={{ fontSize: 22 }} color="text.secondary" gutterBottom>
            Thank you,
          </Typography>
          <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
            Your application has been submitted.
          </Typography>
          <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
            We will review it and be in touch.
          </Typography>
        </CardContent>
      </Card>
    </>
  )
}

export default Success